import { AfterContentInit, AfterViewInit, ChangeDetectorRef, Component, ContentChild, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { map, Observable, of, tap } from 'rxjs';
import { AgentSupervisorDashboardFilterContentComponent } from 'src/app/features/agent-supervisor/components/agent-supervisor-dashboard-container/agent-supervisor-dashboard-board/agent-supervisor-dashboard-filter-content/agent-supervisor-dashboard-filter-content.component';
import { DashboardFilterContentBase } from '../dashboard-filter-content.base';

@Component({
    selector: 'app-dashboard-filter-button',
    templateUrl: './dashboard-filter-button.component.html',
    styleUrls: ['./dashboard-filter-button.component.scss'],
    standalone: false
})
export class DashboardFilterButtonComponent implements OnInit, AfterContentInit {

  @Input() filterEvaluated: boolean = false
  @Output() resetFilter = new EventEmitter()

  @ContentChild(DashboardFilterContentBase) contentEl!: DashboardFilterContentBase<any, any>

  shouldShowResetButton$: Observable<boolean> = of(false)

  displayFilter: boolean = false


  constructor(private readonly cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
  }

  ngAfterContentInit(): void {
    this.shouldShowResetButton$ = this.contentEl.filter.pipe(map(f => !(f.isEmpty())))
    this.cdr.markForCheck()
  }

  onFilterToggle() {
    this.displayFilter = !this.displayFilter
  }

  onResetFilterClick() {
    this.resetFilter.emit()
  }

}
